import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency';

import { ATT_STATUS_STORAGE_KEY, IS_IOS } from '../../common/constants';

export async function requestAttStatusForLogin() {
  if (!IS_IOS) return;

  try {
    const currentStatus = await AppTrackingTransparency.getStatus();
    const attStatus =
      currentStatus.status === 'notDetermined'
        ? (await AppTrackingTransparency.requestPermission()).status
        : currentStatus.status;
    sessionStorage.setItem(ATT_STATUS_STORAGE_KEY, attStatus);
  } catch (error) {
    console.error('Failed to get ATT status before login redirect', error);
    sessionStorage.removeItem(ATT_STATUS_STORAGE_KEY);
  }
}
